import type { StripeCheckoutLineItem } from '@stripe/stripe-js'

import { type LineItem, PriceProductType } from '@/clients/payment-service'

/** Stripe checkout SDK line items do not expose product type — match on name only. */
export const isStripeCheckoutShippingFeeLineItem = (item: StripeCheckoutLineItem): boolean =>
  (item.name ?? '').toLowerCase().includes('shipping')

export const excludeStripeCheckoutShippingFeeLineItems = (
  lineItems: StripeCheckoutLineItem[],
): StripeCheckoutLineItem[] => lineItems.filter((item) => !isStripeCheckoutShippingFeeLineItem(item))

export const findStripeCheckoutShippingFeeLineItem = (
  lineItems: StripeCheckoutLineItem[],
): StripeCheckoutLineItem | undefined => lineItems.find((item) => isStripeCheckoutShippingFeeLineItem(item))

export const SHIPPING_FEE_PRODUCT_TYPE = PriceProductType.SHIPPING_FEE

export const isPaymentApiShippingFeeLineItem = (item: LineItem): boolean =>
  item.price.product_type === SHIPPING_FEE_PRODUCT_TYPE

export const excludePaymentApiShippingFeeLineItems = (lineItems: LineItem[]): LineItem[] =>
  lineItems.filter((item) => !isPaymentApiShippingFeeLineItem(item))

export const findPaymentApiShippingFeeLineItem = (lineItems: LineItem[]): LineItem | undefined =>
  lineItems.find(isPaymentApiShippingFeeLineItem)
